import React from 'react'
import { connect } from 'react-redux'
import { LoginContainer, BG } from './styled'
import { Loading } from 'components'
import { useMsal } from '@azure/msal-react'

const Logout = (props) => {
  const { instance } = useMsal()

  React.useEffect(() => {
    instance.logoutRedirect({
      postLogoutRedirectUri: '/',
    })
  }, [])

  return (
    <LoginContainer>
      <BG/>
      <Loading/>
    </LoginContainer>
  )
}

const mapStateToProps = (state) => ({
})

const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(Logout)
